import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { OKTA_AUTH, OKTA_CONFIG } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import OktaSignIn from '@okta/okta-signin-widget';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root',
})
export class OktaService {
  signIn: any;
  public isUserLoggedIn: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  constructor(
    @Inject(OKTA_AUTH) public oktaAuth: OktaAuth,
    private http: HttpClient,
    private router: Router,
    private sessionservice: SessionService
  ) {
    this.signIn = new OktaSignIn({
      logoText: 'Batch Rater Logo',
      baseUrl: environment.Okta.oidc.issuer.split('/oauth2')[0],
      clientId: environment.Okta.oidc.clientId,
      redirectUri: environment.Okta.oidc.redirectUri,
      logo: 'assets/Images/BatchRater-Logo-black.svg',
      i18n: {
        en: {
          'primaryauth.title': 'Sign in with your email address',
          'oie.remember': 'Remember me',
        },
      },
      authParams: {
        display: 'page',
        pkce: true,
        postLogoutRedirectUri: environment.Okta.oidc.end_session_redirect_uri,
        issuer: environment.Okta.oidc.issuer
      },
      features: {
        idpDiscovery: environment.Okta.oidc.idpEnabled == true,
      },
      idpDiscovery: {
        requestContext: environment.Okta.oidc.idpDiscoveryUrl,
      },
      authClient: oktaAuth as any,
      useClassicEngine: environment.Okta.widget.UseClassicEngine === true,
    });
  }

  OktaProvider() {
    return {
      provide: OKTA_CONFIG,
      useFactory: () => {
        const oktaAuth = new OktaAuth(environment.Okta.oidc);
        oktaAuth.start();
        return {
          oktaAuth,
          onAuthRequired: (oktaAuth: OktaAuth, injector: Injector) => {
            const triggerLogin = () => {
              // Redirect the user to your custom login page
              const router = injector.get(Router);
              router.navigate(['/login']);
            };
            if (
              !oktaAuth.authStateManager.getPreviousAuthState()?.isAuthenticated
            ) {
              // App initialization stage
              triggerLogin();
            } else {
              triggerLogin();
            }
          },
        };
      },
    };
  }

  async OktaAuthObject() {
    var $this = this;
    var sessionUser = JSON.parse(localStorage.getItem('SessionUser'));
    if (sessionUser) {
      this.signIn.authClient.session.exists().then(function (sessionExists) {
        if (sessionExists) {
          if (
            !$this.signIn.authClient.getAccessToken() &&
            !$this.signIn.authClient.getRefreshToken()
          ) {
            //"Access and Id tokens are not found"
            $this.getTokensFromOKTA();
          }
        } else {
          if (
            localStorage.getItem('APITOKEN') != null &&
            localStorage.getItem('APITOKEN') != undefined
          )
            $this.logout();
        }
      });
    }
  }

  getTokensFromOKTA() {
    var $this = this;
    this.signIn.authClient.tokenManager
      .renew('idToken')
      .then(function (freshToken) {})
      .catch(function (err) {
        // handle OAuthError
        $this.logout();
      });
    this.signIn.authClient.tokenManager
      .renew('accessToken')
      .then(function (freshToken) {})
      .catch(function (err) {
        // handle OAuthError
        $this.logout();
      });
  }

  async logout() {
    const oktaBaseUrl: string = `${environment.Okta.oidc.issuer}/v1`;
    const oktaTokenStorage: any = JSON.parse(
      localStorage.getItem('okta-token-storage')
    );
    const oktaIdToken = oktaTokenStorage?.idToken;
    this.isUserLoggedIn.next(false);
    sessionStorage.clear();
    localStorage.clear();
    this.sessionservice.removeLocalStorage('SeesionUser');
    this.sessionservice.removeLocalStorage('APITOKEN');
    this.sessionservice.removeLocalStorage('Menu');
    this.sessionservice.setLocalStorage('loginStatus', '0');
    this.sessionservice.removeLocalStorage('selectedUserId');
    this.oktaAuth.tokenManager.clear();
    await this.signIn.authClient.revokeAccessToken();
    await this.oktaAuth
      .signOut({
        idToken: oktaIdToken,
        postLogoutRedirectUri: environment.Okta.oidc.end_session_redirect_uri,
        revokeAccessToken: false,
        revokeRefreshToken: false,
      })
      .then(() => {
        window.location.href = `${oktaBaseUrl}/logout?id_token_hint=${oktaIdToken.idToken}&post_logout_redirect_uri=${environment.Okta.oidc.end_session_redirect_uri}`;
      });
  }
}
